import { Button, Col, Grid, Icon, NetworkIcon, Typography } from 'gu-ui-kit'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import { DROP_LIST, FETCH } from 'modules/Recommendations/CampaignsRecommendations/TypesList/types'
import { Helmet } from 'react-helmet'
import Breadcrumbs from 'components/Breadcrumbs'
import GridSpinner from 'components/UI/GridSpinner'
import format from 'utils/dateFns/format'
import { parse } from 'date-fns'
import clsx from 'clsx'
import styles from 'modules/Recommendations/CampaignsRecommendations/TypesList/recommendations-list.module.scss'
import { ROUTES } from 'constants/routes'
import { Link } from 'react-router-dom'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import downloadFile from 'utils/downloadFile'
import { notificationShow } from 'modules/Notifications/actions'
import EmptyResults from 'components/EmptyResults'
import { ReactComponent as NoListDataImage } from 'images/illustration/empty-list.svg'
import PageHeader from 'components/PageHeader'

const TypesList = () => {
  const breakpoint = useBreakpoint()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const pathGen = useGeneratePathI18n()

  const { data, loading } = useSelector((state) => ({
    ...state['recommendations/types'],
  }))

  useEffect(() => {
    dispatch({
      type: FETCH,
    })

    return () => {
      dispatch({ type: DROP_LIST })
    }
  }, [])

  return (
    <>
      <Helmet>
        <title>{t('recommendations::header')}</title>
      </Helmet>
      <Breadcrumbs
        links={[
          {
            title: t('recommendations::breadcrumbs.recommendations_root'),
            to: pathGen(ROUTES.RECOMMENDATIONS),
          },
          {
            title: t('recommendations::breadcrumbs.recommendations'),
          },
        ]}
      />
      <PageHeader className={'margin-bottom-40'} color={'Label-Primary'}>
        {t('recommendations::header')}
      </PageHeader>
      {loading && <GridSpinner />}
      <Grid gap={16}>
        {data.length === 0 && !loading && (
          <EmptyResults
            image={<NoListDataImage />}
            header={t('recommendations::types_list.empty_list.header')}
            text={t('recommendations::types_list.empty_list.text')}
            className={styles['recommendations__empty-list']}
          />
        )}
        {data.map((item, i) => (
          <Col key={'recommendation-type-' + i} xs={12} sm={6} fb={6} md={6} lg={3}>
            <Grid
              className={clsx(styles['recommendations__type-item'], 'margin-bottom-20')}
              direction={'column'}
            >
              <Grid gap={12} className={'margin-bottom-32'} direction={'column'}>
                <Typography color={'Label-Secondary'} variant={'Body-15'} component={'div'}>
                  {!item.date ? (
                    <span dangerouslySetInnerHTML={{ __html: '&nbsp;' }} />
                  ) : (
                    t('recommendations::types_list.updated', {
                      date: format(parse(item.date, 'yyyy-MM-dd', new Date()), 'dd.MM.yyyy'),
                    })
                  )}
                </Typography>
                <Typography
                  className={styles['recommendations__type-item-header']}
                  color={'Label-Primary'}
                  component={'h3'}
                  variant={breakpoint.fbs ? 'Subtitle-25' : 'Subtitle-30'}
                >
                  {t(`recommendations::types_list.types.${item.type}.header`)}
                </Typography>
                <Typography
                  color={'Label-Primary'}
                  variant={'Body-15'}
                  dangerouslySetInnerHTML={{
                    __html: t(`recommendations::types_list.types.${item.type}.description`),
                  }}
                />
              </Grid>
              <Grid gap={12}>
                <Grid gap={16} fluid wrap={'nowrap'} alignItems={'center'}>
                  <Col>
                    <Grid alignItems={'center'}>
                      <NetworkIcon rounded width={24} name={'yandex'} />
                    </Grid>
                  </Col>
                  <Col>
                    <Grid gap={8} wrap={'nowrap'} alignItems={'center'}>
                      <Typography variant={'Subtitle-30'} color={'Label-GU-Primary'}>
                        {item.count}
                      </Typography>
                      <Typography variant={'Body-15'} color={'Label-Secondary'}>
                        {t('recommendations::types_list.counted_campaigns', {
                          count: item.count,
                        })}
                      </Typography>
                    </Grid>
                  </Col>
                </Grid>
                <Grid gap={16} fluid wrap={'nowrap'} alignItems={'center'}>
                  <Button
                    className={styles['recommendations__type-item-button']}
                    type={'primary'}
                    variant={'primary'}
                    size={'m'}
                    component={Link}
                    to={pathGen(ROUTES.RECOMMENDATIONS_TYPE, {
                      type: item.type,
                    })}
                  >
                    {t('recommendations::types_list.button')}
                  </Button>
                  <Button
                    noLabel={true}
                    type={'ghost'}
                    color={'Interface-GU-Primary'}
                    startIcon={<Icon name={'file-xls'} />}
                    variant={'secondary'}
                    link
                    size={'s'}
                    component={'a'}
                    onClick={() =>
                      downloadFile(
                        `/api/app/v2/yd/recommendations/${item.type}/file`,
                        'getuniq-recommendations-' + item.type,
                        'xls',
                      ).catch((error) =>
                        dispatch(
                          notificationShow({
                            type: 'warning',
                            message: error.message,
                            delay: 20000,
                          }),
                        ),
                      )
                    }
                  />
                </Grid>
              </Grid>
            </Grid>
          </Col>
        ))}
      </Grid>
    </>
  )
}

TypesList.propTypes = {}

export default TypesList
